export default "/template/resource//static/media/img_qiyehulian@2x.240d8298.png";